import { createSlice } from "@reduxjs/toolkit";

// Manages authentication state, persisted login tokens, and basic user session data.
const loginSlice = createSlice({
  name: "login",
  initialState: {
    user: null,
    token: localStorage.getItem("token") || null,
    isAuthenticated: localStorage.getItem("isAuthenticated") || false,
    loading: false,
    error: null,
    authToken: localStorage.getItem("token") || null,
  },

  reducers: {
    // Marks the start of an auth request and clears any previous error.
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    // Stores the returned auth token and persists the logged-in state for page reloads.
    loginSuccess: (state, action) => {
      console.log("action", action);
      state.authToken = action.payload.user.authToken;
      state.isAuthenticated = true;
      state.loading = false;

      // Save token to localStorage
      localStorage.setItem("token", action.payload.user.authToken);
      localStorage.setItem("isAuthenticated", true);
    },
    // Stores the auth error and resets the authenticated state.
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
    },
    // Clears the active session from Redux and localStorage, then redirects to login.
    logout: (state) => {
      state.authToken = null;
      state.isAuthenticated = false;

      // Remove token from localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("isAuthenticated");
      window.location.href = "/login";
    },
    // Saves the current user's profile payload for screens that need user-specific details.
    AdduserData: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
  AdduserData,
  addUserKycSteps,
} = loginSlice.actions;

export default loginSlice.reducer;
